import { icons } from '../shared-asstes/icons'
import { errorText } from '../shared-constants/texts'
import ErrorSection from '../shared_components/ErrorSection'
const UseInternet = (props) => {
  return (
    <>
      <ErrorSection
        icon={icons.TRY_AGAIN}
        title={errorText.TRY_AGAIN_TITLE}
        description={errorText.TRY_AGAIN_DESCRIPTION}
        hasButton={true}
        buttonText='تلاش مجدد'
        {...props}
      />
    </>
  )
}

export default UseInternet
